var _image, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 72,
    height: 72,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAAAsSAAALEgHS3X78AAAB 2ElEQVR4nO3c2UrDQBiG4aQdL8EuaNVbckc8dEUEr0UQcT0RRNxvyZUul6BtI7YkNiaZrxVBm7zP QaFNCs3HP5NJkxnXGVD53vMG/c5/Up12BzrmvnYu3w13KEmqMzosuUPptp3KcHy12Zw1g8SNpZt0 B/NdbS4+qNgPS9etVFdNktp8PpJH5IPiVTbD8dUXwiGF3hQvm5kOx1dfNEEuJrSl/Ue/6B8Lkipc UD29GkvdKuq8FM7fCSdGY3nE7TYx4knUCchL50D5V7ijZ2+kY2GoHjtD/2NHQAJNTKCCBONQQVaG fOyoIIE+SDAef3FYGa5U7Qx/ktkxUBTopAVO8wIDRYEKEuiDBJqYQBMTaGICA0WBChKMl63npAZG BQkEJNBJC1SQwEBR4FJDoIkJNDGBJiZQQQJ9kMBAUeDGocCtZ4GHFwQ6aYHTvMBAUaCCBPoggYGi QAUJBCR0pmSanVdiitHcHWNKpsKUTCGYFp7ffiGlHq298a9p4b781jMhfYazX4lfeYF0oiKLm+Q2 s11F7YNK8uImvtzGUyZDah9O6OVxgg3r2QrJO4qG4/SzRJe79pjqavKOJ3+2RFdop9V0huSd2MNx +g0oZOVhuMM6ner/mB3H+QD7eKU32arLcgAAAABJRU5ErkJggg=="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.8,38.3l1.2-7.5h-7.3v-5.2c0-2.1,0.8-3.7,4.1-3.7h3.6V15c-1.9-0.3-4.1-0.5-6-0.5 c-6.3,0-10.7,3.7-10.7,10.4v5.9h-6.9v7.5h6.9v18.9c1.5,0.3,3,0.4,4.5,0.4s3-0.1,4.5-0.4V38.3H44.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b1aa31875cf89f7e3517b708fafaeadb.svg";
export { ForwardRef as ReactComponent };